import script from "./generateFromLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./generateFromLogo.vue?vue&type=script&setup=true&lang=js"

import "./generateFromLogo.vue?vue&type=style&index=0&id=b9723548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9723548"]])

export default __exports__